// extracted by mini-css-extract-plugin
module.exports = {"container":"Styles_container__umsGD","footer":"Styles_footer__1qmlw","mobile":"Styles_mobile__1fjAV","tablet":"Styles_tablet__Fz70m","desktop":"Styles_desktop__krw1b"};